import axios from 'axios';
import config from '@/utils/config';

const BASE_URL = `${config.baseUrl}/api/matchmaking`;

/**
 * Get tutor recommendations for a student
 * @param {number} studentId - ID of the student
 * @param {number} k - Number of recommendations to return (default: 10)
 * @param {Array<string>} subjectFilter - Optional array of subject names to filter by
 * @returns {Promise} Response with recommendations
 */
export const getRecommendations = async (studentId, k = 10, subjectFilter = null) => {
  try {
    const response = await axios.post(`${BASE_URL}/recommend`, {
      studentId,
      k,
      subjectFilter
    });
    return response.data;
  } catch (error) {
    console.error('Matchmaking error:', error);
    throw error;
  }
};

/**
 * Get tutor recommendations using GET endpoint (alternative)
 * @param {number} studentId - ID of the student
 * @param {number} k - Number of recommendations to return
 * @param {Array<string>} subjects - Optional array of subject names
 * @returns {Promise} Response with recommendations
 */
export const getRecommendationsSimple = async (studentId, k = 10, subjects = null) => {
  try {
    const params = new URLSearchParams({ k });
    if (subjects && subjects.length > 0) {
      params.append('subjects', subjects.join(','));
    }

    const response = await axios.get(`${BASE_URL}/recommend/${studentId}?${params}`);
    return response.data;
  } catch (error) {
    console.error('Matchmaking error:', error);
    throw error;
  }
};

export default {
  getRecommendations,
  getRecommendationsSimple
};
